// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { RbFragmentDoc } from '../ring-builder/rb.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const RingBuilderResolveExistingCustomerDocument = gql`
    mutation ringBuilderResolveExistingCustomer($input: RingBuilderResolveInput!, $currency: CurrencyInput!, $country: CountryCode!, $locale: Locale!) {
  ringBuilderResolveExistingCustomer(input: $input) {
    __typename
    ... on RingBuilderResolvedExistingCustomerSuccess {
      ringBuilder {
        ...rb
      }
      redirect
    }
    ... on RingBuilderResolvedFailure {
      errors
    }
  }
}
    ${RbFragmentDoc}`;

export function useRingBuilderResolveExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.RingBuilderResolveExistingCustomerMutation, SchemaTypes.RingBuilderResolveExistingCustomerMutationVariables>(RingBuilderResolveExistingCustomerDocument);
};